import { hc } from 'hono/client'
import type { ApiClient } from '@datum/api'

/** Dev: empty base → Vite proxies /api to the worker. Prod: set VITE_API_URL to the worker URL. */
export const API_BASE = import.meta.env.VITE_API_URL ?? ''

export const api = hc<ApiClient>(API_BASE, {
  init: { credentials: 'include' },
})

/** Absolute URL for direct fetches (Better Auth endpoints, raw uploads). */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`
}
